export enum GiftCodePurpose {
  GROUP = 'Group',
  PRODUCE = 'Produce',
  ETC = 'Etc'
}
